import { render, staticRenderFns } from "./ProposalCardHorizontalResponsive.vue?vue&type=template&id=ee175270&"
import script from "./ProposalCardHorizontalResponsive.vue?vue&type=script&lang=js&"
export * from "./ProposalCardHorizontalResponsive.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCardHorizontalResponsive.vue?vue&type=style&index=0&id=ee175270&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports